import React from 'react'
import "./partners.scss"

//Imagens:
import ImgPartnersOne from "../../../assets/partnerships/partnersOne.png";
import ImgPartnersTwo from "../../../assets/partnerships/partnersTwo.png";
import ImgPartnersThree from "../../../assets/partnerships/partnersThree.png";
import ImgPartnersFour from "../../../assets/partnerships/partnersFour.png";

function Partners() {
  return (
    <div className='container-partners'>
        <div className='partners-column-one'>
            <img src={ImgPartnersOne} alt="" />
            <img src={ImgPartnersTwo} alt="" />
        </div>
        <div className='partners-column-two'>
        <img src={ImgPartnersThree} alt="" />
        <img src={ImgPartnersFour} alt="" />
        </div>
    </div>
  )
}

export default Partners